import { render, staticRenderFns } from "./calmDialog.vue?vue&type=template&id=c15cc7ba&scoped=true&"
import script from "./calmDialog.vue?vue&type=script&lang=js&"
export * from "./calmDialog.vue?vue&type=script&lang=js&"
import style0 from "./calmDialog.vue?vue&type=style&index=0&id=c15cc7ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15cc7ba",
  null
  
)

export default component.exports